<div *ngIf="(serviceSteps$ | async).length !== 0; else noDeliverySteps">
  <div class="flex justify-between items-center">
    <!-- BEGIN: The duration paragraph -->
    <div class="flex items-center">
      <span class="px-2">
       {{" Tafadhali fahamu kwamba utaratibu wetu wa utoaji wa huduma unakadiriwa kuchukua hadi"|concat|translate}}
        <span class="font-bold text-primary-500">
          {{ totalYears === 0 ? "" : totalYears + " Year(s)" }}
          {{ totalMonths === 0 ? "" : totalMonths + " Month(s)" }}
          {{ totalWeeks === 0 ? "" : +totalWeeks + " Week(s)" }}
          {{ totalDays === 0 ? "" : +totalDays + " Day(s)" }}
          {{ totalHours === 0 ? "" : +totalHours + " Hour(s)" }}
          {{ totalMinutes === 0 ? "" : +totalMinutes + " Minute(s)" }}
          {{ totalSeconds === 0 ? "" : +totalSeconds + " Second(s)" }}
        </span>
        {{"ili kuhakikisha tunakupatia huduma ya hali ya juu iwezekanavyo"|concat|translate}}
      </span>
    </div>
    <!-- END: The duration paragraph -->
  </div>

  <!-- BEGIN: Service Processes table -->
<!--  <div class="p-3">-->
<!--    <div class="col-md-12 d-flex flex-column move-up">-->
<!--      <div>-->
<!--        <div class="col-12 my-3">-->
<!--          <h3 class="text-primary-500" style="font-weight: 600">{{"Mchakato wa huduma"|concat|translate}}</h3>-->
<!--          <div class="table-responsive">-->
<!--            <table class="table table-bordered bg-light_primary">-->
<!--              &lt;!&ndash; BEGIN: Table header &ndash;&gt;-->
<!--              <thead class="bg-primary-500 text-white">-->
<!--                <tr class="bg-light_primary">-->
<!--                  <th class="mx-2">{{"HATUA"|concat|translate}}</th>-->
<!--                  <th class="mx-2">{{"JINA"|concat|translate}}</th>-->
<!--                  <th class="mx-2">{{"MUDA"|concat|translate}}</th>-->
<!--                  <th class="mx-2">{{"Matokeo"|concat|translate}}</th>-->
<!--                </tr>-->
<!--              </thead>-->
<!--              &lt;!&ndash; END: Table header &ndash;&gt;-->

<!--              &lt;!&ndash; BEGIN: Table body &ndash;&gt;-->
<!--              <tbody>-->
<!--                <tr class="bg-light_primary" *ngFor="let step of serviceSteps$ | async; let i = index">-->
<!--                  <td>{{ i + 1 }}</td>-->
<!--                  <td>{{ step?.stepName }}</td>-->
<!--                  <td>-->
<!--                    <div>-->
<!--                      <span>{{ step.stepTimeInYear === 0 ? "" : step.stepTimeInYear + " Years" }}</span>-->
<!--                      <span>{{ step.stepTimeInMonths === 0 ? "" : +step.stepTimeInMonths + " Months" }}</span>-->
<!--                      <span>{{ step.stepTimeInWeeks === 0 ? "" : +step.stepTimeInWeeks + " Weeks" }}</span>-->
<!--                      <span>{{ step.stepTimeInDays === 0 ? "" : +step.stepTimeInDays + " Days" }}</span>-->
<!--                      <span>{{ step.stepTimeInMinutes === 0 ? "" : +step.stepTimeInMinutes + " Minutes" }}</span>-->
<!--                      <span>{{ step.stepTimeInSec === 0 ? "" : +step.stepTimeInSec + " Seconds" }}</span>-->
<!--                    </div>-->
<!--                  </td>-->
<!--                  <td>{{ step?.stepDecision }}</td>-->
<!--                </tr>-->
<!--              </tbody>-->
<!--              &lt;!&ndash; END: Table body &ndash;&gt;-->
<!--            </table>-->
<!--          </div>-->
<!--          &lt;!&ndash; END: Service processes table &ndash;&gt;-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
  <!-- END: -->
</div>

<ng-template #noDeliverySteps>
  <div class="bg-light_primary col-md-10 mt-4 mx-auto rounded-md p-4 text-center font-medium text-muted move-left">
    {{ "no_service_process" | translate }}
  </div>
</ng-template>
